import ActivityDetail from "@/Component/Module/ActivityDetail";
import NotFound from "@/Component/Module/NotFound";
import SeoHead from "@/Component/Seo/SeoHead";
import { serverFetchActivityDetailsBySlug } from "@/services/server";
import { isMissingActivityDetail, renderNotFoundPage } from "@/utils/detailSlug";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchPageSeo, getDataLayerAuth } from "@/utils/pageSeo";

export default function ActivityDetailPage({
  showNotFound,
  seo,
  seoCountry,
  activitySlug,
  initialDetail,
}) {
  if (showNotFound) {
    return (
      <>
        <SeoHead fallbackTitle="Page not found | Next Holidays" noIndex />
        <NotFound />
      </>
    );
  }

  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Activity Details | Next Holidays"
      />
      <ActivityDetail
        activitySlug={activitySlug}
        initialDetail={initialDetail}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const rawSlug = context.params?.slug;
  const activitySlug = Array.isArray(rawSlug) ? rawSlug[0] : rawSlug || "";

  if (!activitySlug) {
    return renderNotFoundPage(context);
  }

  try {
    const country = getCountryFromContext(context);
    const response = await serverFetchActivityDetailsBySlug(activitySlug, country);
    if (isMissingActivityDetail(response)) {
      return renderNotFoundPage(context);
    }

    const seoResult = await fetchPageSeo(context, {
      dataLayerPayload: {
        module: "activity",
        events: "view_item",
        slug: activitySlug,
        ...getDataLayerAuth(context),
      },
    });
    if (seoResult.redirect) return seoResult;

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        activitySlug,
        initialDetail: response?.data || response || null,
      },
    };
  } catch {
    return renderNotFoundPage(context);
  }
}
